/** Product expiration date of the chosen price break, in the backend's MM/YYYY format. */
export default function getChosenPriceBreakExpiration(
  vendorOption: VendorOptionState | null | undefined,
): string | null {
  if (!vendorOption) return null;

  const chosenPriceBreak = vendorOption.priceBreaks?.find((pb) => pb.pmId === vendorOption.chosenPriceBreakId);

  return chosenPriceBreak?.expirationDate ?? null;
}
